<ng-container>
    <ai-dialog-header
        [title]="title()"
        (close)="onCloseDialog()"
    ></ai-dialog-header>

    <ai-dialog-content>
        <p>{{ message() }}</p>
    </ai-dialog-content>

    <ai-dialog-actions>
        <div>
            <span style="margin-right: 5px">
                <ai-button
                    #cancelButton
                    (click)="onCancelClick()"
                    [label]="cancelButtonLabel()"
                    [variant]="cancelButtonVariant()"
                >
                    @if (cancelButtonIcon()) {
                        <ai-icon [fontIcon]="cancelButtonIcon()!" />
                    }
                </ai-button>
            </span>
            <ai-button
                (click)="onConfirmClick()"
                [label]="confirmButtonLabel()"
                [variant]="confirmButtonVariant()"
            >
                @if (confirmButtonIcon()) {
                    <ai-icon [fontIcon]="confirmButtonIcon()!" />
                }
            </ai-button>
        </div>
    </ai-dialog-actions>
</ng-container>
